// extracted by mini-css-extract-plugin
export default {"wrapper":"QuRFC","space":"btvya","tab":"jg6gO","container":"QR3fV"};